import Swal from "sweetalert2";
import "./popup.css";

/**
 * Themed SweetAlert2 used by every screen, so popups share the Desi Race look
 * (see popup.css). Same call shapes as Swal: popup.fire(title, text, icon) or popup.fire({...}).
 */
const popup = Swal.mixin({
  buttonsStyling: false,
  returnFocus: false,
  confirmButtonText: "OK",
  cancelButtonText: "Cancel",
  customClass: {
    container: "dr-swal-container",
    popup: "dr-swal",
    icon: "dr-swal__icon",
    title: "dr-swal__title",
    htmlContainer: "dr-swal__text",
    actions: "dr-swal__actions",
    confirmButton: "dr-swal__btn dr-swal__btn--confirm",
    cancelButton: "dr-swal__btn dr-swal__btn--cancel",
    timerProgressBar: "dr-swal__timer",
  },
  showClass: { popup: "dr-swal--in", backdrop: "dr-swal-backdrop--in" },
  hideClass: { popup: "dr-swal--out", backdrop: "dr-swal-backdrop--out" },
});

export function escapeHtml(value) {
  return String(value ?? "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;");
}

/** Result popup after an answer: shows the answer, closes itself with a progress bar. */
export function answerPopup({ correct, answer, title, text, confirmButtonText = "Continue", icon }) {
  return popup.fire({
    // icon: null = no icon (used when Skip just reveals the answer)
    icon: icon === undefined ? (correct ? "success" : "error") : icon || undefined,
    title: title || (correct ? "Correct!" : "Not quite!"),
    html: `${text || (correct ? "The answer is" : "The correct answer is")} <b class="dr-swal__answer">${escapeHtml(answer)}</b>`,
    confirmButtonText,
    timer: 3200,
    timerProgressBar: true,
  });
}

export default popup;

/**
 * "Here are the right answers" popup used at submit / skip in every game.
 * items: [{ label, answer, correct?, yours? }] — a correct row gets a green edge and a tick,
 * a wrong row shows what the player answered.
 * columns: lay short items (single words) out side by side instead of one per row.
 */
export function answersPopup({
  title = "Correct answers",
  intro = "",
  items,
  confirmButtonText = "Continue",
  icon,
  columns = false,
}) {
  const rows = items
    .map((item) => {
      const yours =
        !item.correct && item.yours
          ? `<span class="dr-recap__y">Your answer: ${escapeHtml(item.yours)}</span>`
          : "";
      return `<li class="${item.correct ? "is-right" : ""}">${
        item.label ? `<span class="dr-recap__q">${escapeHtml(item.label)}</span>` : ""
      }<span class="dr-recap__a">${item.correct ? "&#10003; " : ""}${escapeHtml(item.answer)}</span>${yours}</li>`;
    })
    .join("");
  return popup.fire({
    icon,
    title,
    html: `${intro ? `<p class="dr-recap__intro">${escapeHtml(intro)}</p>` : ""}<ul class="dr-recap${columns ? " dr-recap--grid" : ""}">${rows}</ul>`,
    confirmButtonText,
    width: columns ? 580 : 540,
  });
}
